import clsx from 'clsx';
import { toast } from 'react-toastify';
import { HighlightedText } from '@/app/components/HighlightedText';
import { stripHtml } from '@/utils/stripHtml';
import { CopyTooltip } from './components/CopyTooltip';
import { defaultCellVariants } from './styles';

interface DefaultCellProps {
  className?: string;
  textClassName?: string;
  children: React.ReactNode | string;
  isCopyable?: boolean;
  title?: string;
  intent?: 'small' | 'base';
  color?: 'grey-700' | 'black';
}

export const DefaultCell = ({
  className,
  children,
  textClassName,
  title,
  intent,
  color = 'grey-700',
  isCopyable = false,
}: DefaultCellProps) => {
  const handleCopy = (event: React.MouseEvent, value: string) => {
    event.stopPropagation();
    if (!isCopyable) return;
    navigator.clipboard.writeText(stripHtml(value));
    toast.info('Copied to clipboard');
  };

  return (
    <div
      className={clsx(defaultCellVariants({ intent }), `text-${color}`, 'cursor-default w-full', className, {
        'flex items-center relative group pr-5': isCopyable,
      })}
      title={title}
    >
      <div className={clsx('line-clamp-2', textClassName)}>
        <HighlightedText>{children}</HighlightedText>
      </div>
      {isCopyable && (
        <button
          className="absolute right-0 top-0 bottom-0 my-auto cursor-pointer group-hover:block hidden"
          style={{ height: 'fit-content' }}
          onClick={(event) => handleCopy(event, children as string)}
        >
          <CopyTooltip />
        </button>
      )}
    </div>
  );
};